// @flow

import React from "react";
import get from "lodash/get";

import { saveFileFromResponse } from "buba-components/src/utils/saveFile";
import styles from "./DownloadFileBundleButton.scss";

type DownloadFileBundleButtonProps = {
  downloadBundleAction: ({ uploaded_file_ids: Array<number> }) => Promise<any>,
  uploadedFileIds: Array<number>,
  addMessage: (string, string) => void,
  inquiryProcessId: number | string
};

const statusErrors = (status: ?number) => {
  switch (status) {
    case 403:
    case 422:
      return `Sie sind aktuell nicht berechtigt, diese Aktion durchzuführen. Bitte ordnen Sie sich die Anfrage zu und wiederholen Sie die Aktion.`;
    case 404:
      return "Leider wurde die Seite nicht gefunden.";
    case 500:
      return "Leider ist ein interner Server-Fehler aufgetreten.";
    default:
      return "Entschuldigung, ein Fehler ist aufgetreten.";
  }
};

const downloadBundle =
  (downloadBundleAction, uploadedFileIds, addMessage, inquiryProcessId) => () => {
    downloadBundleAction(
      { uploaded_file_ids: uploadedFileIds, id: inquiryProcessId },
      { addMessage }
    )
      .then(res => {
        saveFileFromResponse(res);
      })
      .catch(err => {
        const status: ?number = get(err, "response.status", null);

        addMessage(statusErrors(status), "failure");
      });
  };

const DownloadFileBundleButton = ({
  downloadBundleAction,
  uploadedFileIds,
  addMessage,
  inquiryProcessId
}: DownloadFileBundleButtonProps) => (
  <button
    type="button"
    onClick={downloadBundle(downloadBundleAction, uploadedFileIds, addMessage, inquiryProcessId)}
    className={styles.button}
  >
    Alle Dokumente Herunterladen
  </button>
);

export default DownloadFileBundleButton;
